"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExatoUrlResultStatus = void 0;
var ExatoUrlResultStatus;
(function (ExatoUrlResultStatus) {
    /**
     * The call was successful the the URL property contains a valid URL
     */
    ExatoUrlResultStatus[ExatoUrlResultStatus["Success"] = 0] = "Success";
    /**
     * No active exato config found for the given branch
     */
    ExatoUrlResultStatus[ExatoUrlResultStatus["ExatoNotConfigured"] = 1] = "ExatoNotConfigured";
    /**
     * An exception occured during the Http call to the exato API
     */
    ExatoUrlResultStatus[ExatoUrlResultStatus["HttpRequestFailed"] = 2] = "HttpRequestFailed";
    /**
    * Exato refused the provided data and did not generate an URL
    */
    ExatoUrlResultStatus[ExatoUrlResultStatus["Rejected"] = 3] = "Rejected";
    /**
     * exception occured during execution of the command
     */
    ExatoUrlResultStatus[ExatoUrlResultStatus["GeneralError"] = 4] = "GeneralError";
})(ExatoUrlResultStatus = exports.ExatoUrlResultStatus || (exports.ExatoUrlResultStatus = {}));
